import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Flex } from '@coolblue-development/freddy';
import { Proposition } from './shared/Proposition.js';
export const PropositionColumn = ({ propositions, ga4Params }) => (_jsx(Flex, { direction: "column", children: propositions.map((proposition, index) => (_jsx(Box, { children: _jsx(Proposition, { proposition: proposition, ga4Params: ga4Params, index: index + 1 }) }))) }));
//# sourceMappingURL=PropositionColumn.js.map